import { useEffect, useState } from "react";
import { Button, MenuItem, Select } from "@mui/material";
import DatePicker from "../../Modals/datePicker";
import moment from "moment";
const SelectDuration = ({ data, onChange }: any) => {
  const returnPercentData = (currentCount: number, total: number) => {
    if (!total) return;
    return ((currentCount / total) * 100).toFixed(1);
  };
  const [daysCount, setDaysCount] = useState(31);
  const dayObj = {
    1: 31,
    2: 28,
    3: 31,
    4: 30,
    5: 31,
    6: 30,
    7: 31,
    8: 31,
    9: 30,
    10: 31,
    11: 30,
    12: 31,
  };
  const monthObj = {
    1: "January",
    2: "February",
    3: "March",
    4: "April",
    5: "May",
    6: "June",
    7: "July",
    8: "August",
    9: "September",
    10: "October",
    11: "November",
    12: "December",
  };
  const [dateValue, setDateValue] = useState([null, null]);
  useEffect(() => {
    onChange?.({
      dateFrom: dateValue?.[0]
        ? moment(new Date(dateValue[0])).toISOString()
        : "",
      dateTo: dateValue?.[1]
        ? moment(new Date(dateValue[1])).toISOString()
        : "",
    });
  }, [dateValue]);
  const [modalVisible, setModalVisible] = useState(false);
  return (
    <div className="cards s_duration">
      <div className="cards_header">
        <div className="left_s">
          <h2>
            <img src="/static/images/calender_icon.svg" alt="Icon" /> Select
            Duration
          </h2>
        </div>
        <div className="right_s" style={{ gap: "10px" }}>
          {/* {selectedYear?.month !== "0" ? (
            <Select
              value={selectedYear?.day}
              onChange={(e) => {
                setSelectedYear((prev) => ({ ...prev, day: e.target.value }));
              }}
            >
              <MenuItem value="0">Select Day</MenuItem>
              {new Array(dayObj?.[selectedYear?.month] || 31)
                .fill("")
                ?.map((data, index) => (
                  <MenuItem value={index + 1}>{index + 1}</MenuItem>
                ))}
            </Select>
          ) : null}
          {selectedYear?.year !== "0" ? (
            <Select
              value={selectedYear?.month}
              onChange={(e) => {
                setSelectedYear((prev) => ({
                  ...prev,
                  month: e.target.value,
                }));
              }}
            >
              <MenuItem value="0">Select Month</MenuItem>
              {new Array(12).fill("")?.map((data, index) => (
                <MenuItem value={index + 1}>{monthObj?.[index + 1]}</MenuItem>
              ))}
            </Select>
          ) : null}
          <Select
            value={selectedYear?.year}
            onChange={(e) => {
              setSelectedYear((prev) => ({ ...prev, year: e.target.value }));
            }}
          >
            <MenuItem value="0">Select Year</MenuItem>
            {new Array(new Date().getFullYear() - 2023)
              .fill("")
              ?.map((data, index) => (
                <MenuItem value={(new Date().getFullYear() - index).toString()}>
                  {new Date().getFullYear() - index}
                </MenuItem>
              ))}
          </Select> */}
          <Button
            className="btn btn_highlight"
            onClick={() => setModalVisible(true)}
          >
            <img src="/static/images/calender_icon.svg" alt="Icon" /> Choose
            Date
          </Button>
        </div>
      </div>
      <ul className="duration_list gap_p">
        <li>
          <figure>
            <img src="/static/images/duration_icon5.svg" alt="" />
          </figure>
          <p>
            <b>
              {data?.travelTypeCounts?.travelTypeCounts?.AIRLINES ||
                // find(
                //   (data2: any) => data2?.travelType == "AIRLINES"
                // )?.count
                0}
            </b>
            <span>Travel through airline</span>
          </p>
        </li>
        <li>
          <figure>
            <img src="/static/images/duration_icon4.svg" alt="" />
          </figure>
          <p>
            <b>
              {data?.travelTypeCounts?.travelTypeCounts?.RAILWAY ||
                // find(
                //   (data2: any) => data2?.travelType == "RAILWAY"
                // )?.count
                0}
            </b>
            <span>Travel through train</span>
          </p>
        </li>
        <li>
          <figure>
            <img src="/static/images/duration_icon3.svg" alt="" />
          </figure>
          <p>
            <b>
              {data?.travelTypeCounts?.travelTypeCounts?.VOYAGE ||
                // find(
                //   (data2: any) => data2?.travelType == "VOYAGE"
                // )?.count
                0}
            </b>
            <span>Travel through ship</span>
          </p>
        </li>
        <li>
          <figure>
            <img src="/static/images/duration_icon2.svg" alt="" />
          </figure>
          <p>
            <b>
              {data?.travelTypeCounts?.travelTypeCounts?.PRIVATE_VEHICLE ||
                // find(
                //   (data2: any) => data2?.travelType == "PRIVATE_VEHICLE"
                // )?.count
                0}
            </b>
            <span>Travel through car</span>
          </p>
        </li>
        <li>
          <figure>
            <img src="/static/images/duration_icon1.svg" alt="" />
          </figure>
          <p>
            <b>
              {data?.travelTypeCounts?.travelTypeCounts?.PUBLIC_ROAD ||
                // find(
                //   (data2: any) => data2?.travelType == "PUBLIC_ROAD"
                // )?.count
                0}
            </b>
            <span>Travel through bus</span>
          </p>
        </li>
        <li>
          <figure>
            <img src="/static/images/duration_icon1.svg" alt="" />
          </figure>
          <p>
            <b>
              F{" "}
              {returnPercentData(
                data?.travelGenderData?.genderBreakdown?.find(
                  (data2: any) => data2?.gender == "2"
                )?.total || 0,
                data?.travelGenderData?.overallTotal
              ) || 0}
              % - M{" "}
              {returnPercentData(
                data?.travelGenderData?.genderBreakdown?.find(
                  (data2: any) => data2?.gender == "1"
                )?.total || 0,
                data?.travelGenderData?.overallTotal
              ) || 0}
              %
            </b>
            <span>Travelers Gender</span>
          </p>
        </li>
        <li>
          <figure>
            <img src="/static/images/duration_icon1.svg" alt="" />
          </figure>
          <p>
            <b>
              F{" "}
              {returnPercentData(
                data?.shipmentGenderData?.genderBreakdown?.find(
                  (data2: any) => data2?.gender == "2"
                )?.total || 0,
                data?.shipmentGenderData?.overallTotal
              ) || 0}
              % - M{" "}
              {returnPercentData(
                data?.shipmentGenderData?.genderBreakdown?.find(
                  (data2: any) => data2?.gender == "1"
                )?.total || 0,
                data?.shipmentGenderData?.overallTotal
              ) || 0}
              %
            </b>
            <span>Shipping Customer</span>
          </p>
        </li>
      </ul>
      <DatePicker
        value={dateValue}
        setValue={setDateValue}
        open={modalVisible}
        onClose={() => {
          setModalVisible(true);
        }}
        setOpen={setModalVisible}
      />
    </div>
  );
};

export default SelectDuration;
